export enum DetailMainFlgEnum {
  NOT_MAIN = '0',
  MAIN = '1',
}
